import useStyles from "./style";
import { Box, Button, Flex, Loader } from "@mantine/core";
import ViewInvoiceDrawer from "./ViewInvoiceDrawer";
import { useDisclosure } from "@mantine/hooks";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useSelector } from "react-redux";

const UpcomingBillingCard = ({
  connected,
  upcomingInvoice,
  loadingAccounts,
}) => {
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const [
    viewInvoiceDrawerOpened,
    { open: viewInvoiceDrawerOpen, close: viewInvoiceDrawerClose },
  ] = useDisclosure(false);
  const { classes } = useStyles();

  const handleDownloadPDF = async () => {
    // Create a hidden div for PDF content
    const pdfContent = document.createElement("div");
    pdfContent.style.padding = "20px";
    pdfContent.style.fontFamily = "Inter";
    pdfContent.innerHTML = `
        <h2>Invoice Summary</h2>
        <p><strong>Billing To:</strong> ${profile?.user?.name}</p>
        <p><strong>Plan:</strong> $${upcomingInvoice?.nextPayment} / ${upcomingInvoice?.duration}</p>
        <p><strong>Status:</strong> Upcoming</p>
      `;
    document.body.appendChild(pdfContent);

    // Convert HTML to canvas
    const canvas = await html2canvas(pdfContent, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    // Create PDF
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");

    // Remove temporary div
    document.body.removeChild(pdfContent);
  };

  return (
    <Box className={classes.card}>
      <p className={classes.cardHdng}>Upcoming Billing</p>
      <Flex className={classes.infoWrapper}>
        {loadingAccounts ? (
          <Loader color="yellow" size={"md"} />
        ) : (
          <>
            <Flex className={classes.labelValueWrapper}>
              <p className={classes.label}>Next payment:</p>
              <p className={classes.value}>${upcomingInvoice?.nextPayment}</p>
            </Flex>
            <Flex className={classes.labelValueWrapper}>
              <p className={classes.label}>Date:</p>
              <p className={classes.value}>{upcomingInvoice?.date}</p>
            </Flex>
            {connected?.map((data) => {
              const {
                creditCard,
                cardName,
                cardNumber,
                accountNumber,
                routingNumber,
                isActive,
              } = data;
              if (!isActive) return;
              return (
                <Flex className={classes.labelValueWrapper}>
                  <p className={classes.label}>Method:</p>
                  <p className={classes.value}>
                    {creditCard && "Card "}
                    {creditCard ? cardNumber || "" : routingNumber || ""}
                  </p>
                </Flex>
              );
            })}
          </>
        )}
      </Flex>
      {!loadingAccounts && (
        <Flex className={classes.btnWrapper}>
          <Button className={classes.viewBtn} onClick={viewInvoiceDrawerOpen}>
            View Invoice Details
          </Button>
          <Button className={classes.downloadBtn} onClick={handleDownloadPDF}>
            Download Invoice
          </Button>
        </Flex>
      )}
      <ViewInvoiceDrawer
        drawerOpened={viewInvoiceDrawerOpened}
        drawerClose={viewInvoiceDrawerClose}
        upcomingInvoice={upcomingInvoice}
      />
    </Box>
  );
};

export default UpcomingBillingCard;
